import { SupplierGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { Supplier } from "./interfaces";

export const makeSupplier = ({ connection, company }: ApiSliceParams) => {
    const {
        items: suppliers,
        allLoading: loading,
        get,
        listen,
    } = createListController<SupplierGet, Supplier>({
        name: "supplier",
        connection,
        list: (con) => con.supplier.items({ company: company.value }),
    });

    return {
        suppliers,
        loading,
        listen,
        get,
    };
};
